import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TenantState {
  tenantId: string | null;
  displayName: string | null;
  logoUrl: string | null;
  setTenant: (tenantId: string, displayName: string, logoUrl?: string) => void;
  clearTenant: () => void;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      tenantId: null,
      displayName: null,
      logoUrl: null,
      setTenant: (tenantId, displayName, logoUrl) =>
        set({ tenantId, displayName, logoUrl: logoUrl ?? null }),
      clearTenant: () => set({ tenantId: null, displayName: null, logoUrl: null }),
    }),
    { name: 'agrovid-tenant' }
  )
);
